import pathnames from '@src/app/routes/pathnames';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

interface AuthWrapperProps {
  children: React.ReactNode;
}

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const isLoggingOut = localStorage.getItem('is_logging_out');

    if (isLoggingOut === 'true') {
      localStorage.removeItem('is_logging_out');

      if (location.pathname !== pathnames.login()) {
        history.replace(pathnames.login());
      }

      setIsReady(true);
      return;
    }
    setIsReady(true);
  }, [location.pathname, history]);

  // Show loading while checking logout state
  if (!isReady) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-gray-700">Loading...</p>
      </div>
    );
  }

  return <div>{children}</div>;
};
